// Re-export the reusable hook from utils
export { useResponsiveStyles } from '../../../utils/useResponsiveStyles';
